import Armature from '../Armature';

export default class RewardCoinsEffect extends Armature {
    public create(params: any): void {
        super.create({
            ...params,
            name: 'rewardCoinsContainer',
            dragonbonesName: 'CurrencyRewards',
            armatureName: 'winCoins_VFX',
            animationName: `winCoins0${params.coins}`,
        });
    }
}
